export function FormError({ message }: { message?: string }): React.JSX.Element | null {
  if (!message) return null;
  return (
    <div style={{
      color: 'var(--color-danger, #c33)',
      fontSize: 12,
      marginTop: 4,
    }}>{message}</div>
  );
}
